'use client';

import { FC } from 'react';

import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { useTranslations } from '@ravago/shared/translations/client';

export const BrandPortfolioListContentButton: FC = () => {
   const translate = useTranslations();

   return (
      <Button variant="secondary" trailingIcon="arrow-right">
         {translate('producer-card-see-all-brands')}
      </Button>
   );
};
